import React from "react";
import { Row, Col, Button, FormGroup, Input } from "reactstrap";
import { connect } from "react-redux";
import { resetResponseValues } from "../../../datautils/actions/responseHandlerActions";
import { searchProduct } from "../../../datautils/actions/adminActions";

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      term: "",
      page: "product",
      newList: []
    };
  }

  handleKeyDown = e => {
    if (e.key === "Enter") {
      this.props.searchProduct({ globalSearchKeyword: this.state.term });
    }
  };

  searchCat = () => {
    this.props.searchProduct({ globalSearchKeyword: this.state.term });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { term, page } = this.state;
    const { dObjectData } = this.props;

    const data =
      dObjectData.productList &&
      dObjectData.productList.data &&
      dObjectData.productList.data.products
        ? dObjectData.productList.data.products
        : null;

    return (
      <div className="attributes-form-box">
        <h5>Search {page} and attach</h5>
        <Row>
          <Col md="12">
            <React.Fragment>
              <FormGroup>
                <div className="has-search">
                  <div className="input-group">
                    <Input
                      type="search"
                      name="term"
                      placeholder={`Search ${page}`}
                      onChange={this.handleChange}
                      value={term}
                      onKeyDown={this.handleKeyDown}
                    />
                    <div className="input-group-append">
                      <Button
                        color="primary"
                        onClick={this.searchCat}
                        disabled={term.length < 1}
                      >
                        <i className="now-ui-icons ui-1_zoom-bold" />
                      </Button>
                    </div>
                  </div>
                </div>
              </FormGroup>

              <div style={{ minHeight: 390, display: "flex" }}>
                {data ? (
                  <ul
                    className="brand-suggest"
                    style={{ minHeight: 390, width: "100%" }}
                  >
                    {Object.keys(data).map(function(keyName, keyIndex) {
                      const row = data[keyName];

                      return (
                        <li key={"pdct-" + keyIndex}>
                          {row.title} ({row.categoryName})
                          <span
                            className="badge badge-success pull-right"
                            onClick={this.props.handleAttachment({
                              entityLabel: row.title,
                              entityType: "PRODUCT",
                              entityIdentifierField: "id",
                              entityIdentifierFieldValue: row.productId,
                              status: "ACTIVE",
                              weight: 2
                            })}
                          >
                            Select
                          </span>
                        </li>
                      );
                    }, this)}
                  </ul>
                ) : null}
              </div>
              <FormGroup />
            </React.Fragment>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state.ui.isLoading,
    dObjectData: state.resHandlerVal.dObjectData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetResponseValues: () => dispatch(resetResponseValues()),
    searchProduct: reqParam => dispatch(searchProduct(reqParam))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
